<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Gruppi di Partecipanti',
      link: '/gruppi-partecipanti'
    }, {
      label: form.uuid ? 'Modifica Gruppo di Partecipanti' : 'Aggiungi nuova Gruppo di Partecipanti'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.name"
      :error-fields="errorFields"
      name="name"
      :submitted="submitted"
    >
      Nome
    </InputText>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from "vue";

import InputBoolean from "@/components/form/InputBoolean.vue";
import InputInteger from "@/components/form/InputInteger.vue";
import InputText from "@/components/form/InputText.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();

let form = reactive({
  name: ""
});

if (props.id) {
  const resp = await axios.get("/company-group/" + props.id);
  form = reactive(resp.data);
}

const rules = {
  name: {
    type: "string",
    max: 64,
    required: true,
  },
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'company-group', rules, {
  create: 'Gruppo di Partecipanti creato con successo',
  update: 'Gruppo di Partecipanti modificato con successo'
}, '/gruppi-partecipanti', () => {
  form.name = '';
})

</script>
